import React from 'react';
import { V1SectionContainer } from './V1SectionContainer';
import { FileText, ArrowRight } from 'lucide-react';

interface Section {
  id: string;
  typeOf: string;
  customTitle?: string;
  sectionOption?: any;
  sectionData?: {
    formsCount?: number;
  };
}

interface V1FormsSectionProps {
  section: Section;
}

/**
 * V1 Forms Section - FROZEN
 *
 * Displays available forms count with link to forms page.
 * Simple display without listing actual forms.
 *
 * DO NOT add V2 features to this component.
 */
export const V1FormsSection: React.FC<V1FormsSectionProps> = ({ section }) => {
  const formsCount = section.sectionData?.formsCount || 0;

  if (formsCount === 0) {
    return (
      <V1SectionContainer section={section}>
        {section.customTitle && (
          <h2 className="text-2xl font-bold mb-4">{section.customTitle}</h2>
        )}
        <div className="text-center py-8">
          <FileText className="mx-auto h-12 w-12 text-gray-400 mb-3" />
          <p className="text-gray-500">No forms available at this time.</p>
        </div>
      </V1SectionContainer>
    );
  }

  return (
    <V1SectionContainer section={section}>
      {section.customTitle && (
        <h2 className="text-2xl font-bold mb-6">{section.customTitle}</h2>
      )}

      <div className="bg-blue-50 rounded-lg p-6 text-center">
        <FileText className="mx-auto h-16 w-16 text-blue-600 mb-4" />
        <p className="text-2xl font-semibold text-gray-900 mb-2">
          {formsCount}
        </p>
        <p className="text-gray-600 mb-4">
          {formsCount === 1 ? 'Form' : 'Forms'} Available
        </p>

        <a
          href="/forms"
          className="inline-flex items-center px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
        >
          View Forms
          <ArrowRight className="ml-2 h-4 w-4" />
        </a>
      </div>

      <div className="mt-6 text-sm text-gray-500 text-center">
        <p>Complete available forms to provide event organizers with important information.</p>
      </div>
    </V1SectionContainer>
  );
};